import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getGatsbyImageData } from 'gatsby-source-sanity';
import React from 'react';
import { sanityConfig } from '../../../sanity-config';
import * as classes from './PortableHeader.module.scss';

const PortableHeaderComponents = {
  types: {
    imageWithAlt: ({ value }) => (
      <div className={classes.imageWrapper}>
        <GatsbyImage alt={value.alt} image={getGatsbyImageData(value.image.asset._ref, { height: 45 }, sanityConfig)} />
      </div>
    ),
  },
  block: {
    subtitle: ({ children }) => <p className={classes.subtitle}>{children}</p>,
    normal: ({ children }) => <p className="content">{children}</p>,
  },
};

export const PortableHeader = ({ content, className }) => (
  <div className={[classes.wrapper, className].join(' ')}>
    <PortableText value={content} components={PortableHeaderComponents} />
  </div>
);
